export default "__VITE_ASSET__DU3w6AqB__"